<template>
    <div class="banner nunito" :class="urlImg ? 'background' : ''"
        :style="{ '--paddingY': paddingY, '--background': backgroundColor, 'background-image': 'url(' + urlImg + ')' }"
        v-show="show">
        <div class="content"
            :style="{ '--aligment-content': aligmentContent, 'text-align': aligmentContent == 'start' ? 'left' : aligmentContent == 'end' ? 'right' : 'center' }">
            <div class="container">
                <h1 :style="{ '--colorTitle': colorTitle || 'black' }">{{ title }}</h1>
                <p v-if="paragraph" :style="{ '--colorParagraph': colorParagraph || 'black' }">{{ paragraph }}</p>
                <div class="content-btn" v-if="buttonLabel && buttonLink">
                    <a :style="{ 'background': buttonBackground, 'color': buttonColor }" :href="buttonLink"
                        :title="buttonLabel">{{ buttonLabel }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BannerComponent',
    props: {
        title: {
            type: String,
            required: true
        },
        paragraph: {
            type: String,
            default: ''
        },
        show: {
            type: Boolean,
            default: true
        },
        colorTitle: {
            type: String,
            default: 'black'
        },
        colorParagraph: {
            type: String,
            default: '#ccc'
        },
        backgroundColor: {
            type: String,
            default: 'white'
        },
        urlImg: {
            type: String,
            default: ''
        },
        buttonLabel: {
            type: String,
            default: ''
        },
        buttonLink: {
            type: String,
            default: ''
        },
        buttonColor: {
            type: String,
            default: 'black'
        },
        buttonBackground: {
            type: String,
            default: 'white'
        },
        aligmentContent: {
            type: String,
            default: 'center'
        },
        paddingY: {
            type: String,
            default: '150px'
        }
    }
}
</script>

<style lang="scss" scoped>
body.dark-theme .banner {
    background-image: none !important;
    background: transparent;

    .content {
        .container {
            h1 {
                color: white;
            }
        }
    }

}

body.dark-theme .banner.background {
    background-image: none !important;
    background: transparent;

    &::before {
        content: none;
    }
}

.banner.background {
    position: relative;
    background-size: cover;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.669);
    }

    .content {
        .container {
            h1 {
                color: white;

            }

            p {
                color: rgb(218, 216, 216);
            }
        }
    }
}

.banner {
    max-width: 1280px;
    width: 100%;
    margin: 0 auto;
    background: var(--background);
    padding: var(--paddingY) 0px;


    .content {
        width:90%;
        margin: 0 auto;
        display: flex;
        position: relative;
        z-index: 2;
        justify-content: var(--aligment-content);

        .container {
            max-width: 600px;
            width: 100%;

            h1 {
                font-size: 2.8rem;
                color: var(--colorTitle);
                @media (max-width: 480px) {
                    font-size:2rem;
                }
                @media (max-width: 768px) {
                    font-size:2.2rem;
                }
            }

            p {
                color: var(--colorParagraph);
            }

            a {
                margin-top: 20px;
                border-radius: 5px;
                cursor: pointer;
                display: inline-block;
                padding: 10px 15px;
                text-decoration: none;
            }
        }
    }
}
</style>
